import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Loyaltic } from './api-url.constants';
import { BehaviorSubject, lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  private loggedIn$ = new BehaviorSubject<boolean>(false);
  private loadSlotResponse$ = new BehaviorSubject<boolean>(false);
  videoAnimationLink = '';
  campaignStart = '';
  campaignEnd = '';
  hasGame = false;

  // Expose it as observable
  isLoggedIn$ = this.loggedIn$.asObservable();

  loadResponse$ = this.loadSlotResponse$.asObservable();

  login() {
    this.loggedIn$.next(true);
  }

  logout() {
    this.loggedIn$.next(false);
  }

  loadResponse() {
    this.loadSlotResponse$.next(true);
  }

  constructor(private http: HttpClient) { }

  signUp(userName) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureEmail, JSON.stringify({ Email: userName }))
      .toPromise().then(response => {
        return response;
      });
  }

  getLiveConfig() {
    return lastValueFrom(this.http.get(environment.baseUrl + Loyaltic.API.LiveConfig))
      .catch(error => {
        // If it's a geo-restriction error, propagate it
        if (error.status === 403 && error.error?.message === 'This service is only available from Finland.') {
          throw error;
        }
        console.error('Failed to get live config, returning default', error);
        return {
          result: {
            liveDate: '2025-10-01T00:00:00Z',
            liveUrls: []
          }
        };
      });
  }

  logIn(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Login, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  upLoadReceipt(payload) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Upload,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  participate(payload) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Participate,
      payload)
      .toPromise().then(response => {
        return response;
      });;
  }

  getRewardList() {
    return this.http.get(environment.baseUrl + Loyaltic.API.GetRewards);
  }

  hasGames(userId:string) {
    return this.http.get(environment.baseUrl + Loyaltic.API.HasGames  + '?userid=' + userId);
  }

  RegUploadWithRealTimeScanning(payload) {
    return this.http.post(environment.baseUrl + Loyaltic.API.RegUploadWithRealTimeScanning,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  loginWithUploadReceipt(payload) {
    return this.http.post(environment.baseUrl + Loyaltic.API.LoginWithUploadReceipt,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  checkCode(payload) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CheckCode,
      payload)
      .toPromise().then(response => {
        return response;
      });
  }

  getAvailableGames(userId, slotId) {
    return this.http.get(environment.baseUrl + Loyaltic.API.AvailableGames + '?userid=' + userId + '&slotid=' + slotId).toPromise().then(response => {
      return response;
    });
  }

  getAvailableSlots(userId) {
    return this.http.get(environment.baseUrl + Loyaltic.API.AvailableSlots + '?userid=' + userId).toPromise().then(response => {
      return response;
    });
  }
  Phonenumberexists(phoneNumber) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Phonenumberexists + '?PhoneNumber=' + phoneNumber, { }).toPromise().then(response => {
      return response;
    });
  }

  play(userId, playType, gameId) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Play, JSON.stringify({ UserId: userId, PlaySource: playType, GameId: gameId }));
  }

   testwin(rewardid) {
    return this.http.get(environment.baseUrl + Loyaltic.API.TestWin + '?reward=' + rewardid)
      .toPromise().then(response => {
        return response;
      });
  }



  captureAddress(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureAddress, JSON.stringify(body))
      .toPromise().then(response => {
        return response;
      });
  }

  captureDigitalWin(payload) {
    return this.http.post(environment.baseUrl + Loyaltic.API.CaptureDigitalWin , payload)
      .toPromise().then(response => {
        return response;
      });
  }

  confirmReceiptUpload(partitionKey, rowKey) {
    return this.http.post(environment.baseUrl +
      Loyaltic.API.confirmuploadafterscanning + '?PartitionKey=' + partitionKey + '&RowKey=' + rowKey, null)
      .toPromise().then(response => {
        return response;
      });
  }

  emailReminder(body) {
    return this.http.post(environment.baseUrl + Loyaltic.API.Emailreminder, JSON.stringify(body)).toPromise().then(response => {
      return response;
    });
  }

  getEmailAndPhone(userId){
    return this.http.get(environment.baseUrl + Loyaltic.API.UserEmailPhone + '?userid=' + userId).toPromise().then(response => {
      return response;
    });
  }

}
